exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-0b54a31e] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.feature-upload[data-v-0b54a31e], .feature-chat[data-v-0b54a31e]\n{\n  display: none;\n}\n\n", ""]);

// exports
